import { BtnParticipar } from '../../componentes/btnParticipar'
import { css } from '@emotion/css'
import { BtnWebPalermo } from '../../componentes/btnWebPalermo'
export function SweetPalermo() {
    return (
        <>
            <article>
                <div className="wrapper mx-auto">
                    <img src="/assets/img/sweetpalermo/sweetpalermo.png" alt="Sweet Palermo" />
                </div>
                <div className="wrapper flex justify-center py-6 bg-[#CE3235]">
                    <BtnWebPalermo />
                </div>
                <div className="wrapper mx-auto px-4 mt-8">
                    <img
                        src="/assets/img/sweetpalermo/sweetpalermo2.png"
                        alt="El triple de vitamina C"
                    />
                </div>
                <div className="wrapper mx-auto px-4 mt-8">
                    <img
                        src="/assets/img/sweetpalermo/sweetpalermo3.png"
                        alt="La estrella Gourmet"
                    />
                </div>
                <div className="wrapper mx-auto px-4 mt-8">
                    <img
                        src="/assets/img/sweetpalermo/sweetpalermo4.png"
                        alt="La estrella Gourmet"
                    />
                </div>
                <div className="wrapper">
                    <BtnParticipar />
                </div>
            </article>
        </>
    )
}
